import { BaseModel } from './base.model';

export interface Contact {
    id: number;
    name: string;
    address: string;
    email: string;
    phoneNumber: string;
  }

  export class Contact implements BaseModel {
    id: number;
    name: string;
    address: string;
    email: string;
    phoneNumber: string;

    constructor();
    constructor(id: number, name: string, address: string, email: string, phoneNumber: string);

    constructor(id?: number, name?: string, address?: string, email?: string, phoneNumber?: string) {
      if (id !== undefined) {
        this.id = id;
      }

      if (name !== undefined) {
        this.name = name;
      } else {
        this.name = '';
      }

      if (address !== undefined) {
        this.address = address;
      } else {
        this.address = '';
      }

      if (email !== undefined) {
        this.email = email;
      } else {
        this.email = '';
      }

      if (phoneNumber !== undefined) {
        this.phoneNumber = phoneNumber;
      } else {
        this.phoneNumber = '';
      }
    }

    getApiName(): string {
      return 'contact';
    }

    getName(): string {
      return 'Contacto';
    }

    getNamePl(): string {
      return 'Contactos';
    }
  }